import reduceReducers from "reduce-reducers";
import basicReducer from "./basicReducer";
import testReducer from "./testReducer";
import loadDataReducer from "./loadDataReducer";
import modalReducer from "./modalReducer";
import modifyDataReducer from "./modifyDataReducer";
import modifyTicketDataReducer from "./modifyTicketDataReducer";
import newWorkOrderReducer from "./newWorkOrderReducer";
import srmRecordReducer from "./srmRecordReducer";
import unifiedFormReducer from "./unifiedFormReducer";
import userReducer from "./userReducer";
import auth from "./auth";

import settingReducer from "../pages/rentalBoard/reducers/settingReducer";
import assetsReducer from "../pages/rentalBoard/reducers/assetsReducer";
import pageReducer from "../pages/rentalBoard/reducers/pageReducer";
import statusColorReducer from "../pages/rentalBoard/reducers/statusColorReducer";
import lastUpdatedReducer from "../pages/rentalBoard/reducers/lastUpdatedReducer";
import prevSettingReducer from "../pages/rentalBoard/reducers/prevSettingReducer";
import statusReducer from "../pages/rentalBoard/reducers/statusReducer";
import statusDescription from "../pages/rentalBoard/reducers/statusDescriptionReducer";
import urlReducer from "../pages/rentalBoard/reducers/urlReducer";

const appReducer = reduceReducers(
  basicReducer,
  loadDataReducer,
  modalReducer,
  auth,
  newWorkOrderReducer,
  modifyDataReducer,
  modifyTicketDataReducer,
  srmRecordReducer,
  unifiedFormReducer,
  userReducer,
  settingReducer,
  assetsReducer,
  pageReducer,
  statusColorReducer,
  lastUpdatedReducer,
  prevSettingReducer,
  statusReducer,
  statusDescription,
  urlReducer,
  testReducer
);
export default appReducer;
